
import Vue, { PropType } from 'vue'
import { Connector, Project } from '../../../../../types/main'
import AudienceTitleWithParams from './AudienceTitleWithParams.vue'
import cloneDeep from 'lodash/cloneDeep'
import MessageSettings from '../MessageSettings.vue'
export default Vue.extend({
    name: 'MessageModal',
    components: {AudienceTitleWithParams, MessageSettings},
    props: {
        value: { type: Boolean as PropType<boolean> },
        activation: { type: Object as PropType<any> },
        automailValidate: { type: Object as PropType<any> },
        activationId: { type: Number as PropType<number> },
    },
    data: () => ({
        initMessageValues: null,
    }),
    computed: {
        isDialog: {
            get(): boolean {
                return this.value
            },
            set(value: boolean): void {
                this.$emit('input', value)
            },
        },
        project(): Project {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        messageParts(): any {
            return this.initMessageValues.message.messageParts
        }
    },
    watch: {
        isDialog(val) {
            if (val) {
                this.initData()
            } else {
                this.initMessageValues = null
            }
        },
    },
    methods: {
        initData() {
            this.initMessageValues = cloneDeep(this.activation)
        },
        applyAndClose() {
            this.$emit('set-val', this.activationId, this.messageParts)
            this.activation.message = this.initMessageValues.message
            this.initMessageValues = null
            this.isDialog = false
            
        },
        close() {
            this.initMessageValues = null
            this.isDialog = false
        }
    },
})
